module.exports = __webpack_public_path__ + "img/empty.491d4099.png";